import { useTheme } from "styled-components";
import { useLanguageContext } from "../../../context/LanguageContext";
import {
  StyledFlexColumn,
  StyledFlexItem,
  StyledFlexRow,
} from "../../../styles/LayoutStyles";
import OverlayLoader from "../../../components/loader/OverlayLoader/OverlayLoader";
import FormContainer from "../../../components/formContainer/FormContainer";
import InputWrapper from "../../../components/input/wrapper/InputWrapper";
import EVAApiHelper from "../../../helpers/EVAApiHelper";
import { StyledInput } from "../../../styles/InputStyles";
import Select from "../../../components/select/main/Select";
import AzureFieldMappings from "./mapping/field/AzureFieldMappings";
import AzureRoles from "./roles/AzureRoles";
import { StyledAltButton } from "../../../styles/ButtonStyles";
import HiddenLoader from "../../../components/loader/HiddenLoader/HiddenLoader";

//The roles and field mappings are saved with the config, so their inputs belong to the config form
const FORM_ID = "azure_configs_form";

function AzureConfigsPageView({
  configData,
  departments,
  roles,
  submitError,
  setConfigData,
  onSync,
  onSubmit,
  onActiveChange,
  onTenantIdChange,
  onClientIdChange,
  onClientSecretChange,
  onEmployeeAzureGroupIdChange,
  onConnectEmployeesToUsersChange,
}) {
  const theme = useTheme();
  const { translate } = useLanguageContext();

  return (
    <StyledFlexColumn style={{ gap: theme.spacing.large }}>
      <OverlayLoader groups="azure_configs_page_fetch">
        <FormContainer
          formId={FORM_ID}
          onSubmit={onSubmit}
          submitError={submitError}
          submitLoadingGroup={"azure_configs_page_save"}
          actions={
            configData.id && (
              <HiddenLoader groups="azure_configs_page_sync">
                <StyledAltButton onClick={onSync} disabled={!configData.active}>
                  {translate("eva.main.general.sync")}
                </StyledAltButton>
              </HiddenLoader>
            )
          }
        >
          <StyledFlexColumn>
            <InputWrapper
              label={translate("eva.main.validation.attributes.active")}
              required
              error={EVAApiHelper.getResponseError("active", submitError)}
            >
              <Select
                options={[
                  { value: true, label: translate("eva.main.general.yes") },
                  { value: false, label: translate("eva.main.general.no") },
                ]}
                value={configData.active}
                onChange={onActiveChange}
              />
            </InputWrapper>

            <InputWrapper
              label={translate("eva.main.validation.attributes.tenant_id")}
              required
              error={EVAApiHelper.getResponseError("tenant_id", submitError)}
            >
              <StyledInput
                type="text"
                placeholder={translate(
                  "eva.main.validation.attributes.tenant_id",
                )}
                value={configData.tenant_id}
                onChange={onTenantIdChange}
              />
            </InputWrapper>

            <StyledFlexRow>
              <StyledFlexItem>
                <InputWrapper
                  label={translate("eva.main.validation.attributes.client_id")}
                  required
                  error={EVAApiHelper.getResponseError(
                    "client_id",
                    submitError,
                  )}
                >
                  <StyledInput
                    type="text"
                    placeholder={translate(
                      "eva.main.validation.attributes.client_id",
                    )}
                    value={configData.client_id}
                    onChange={onClientIdChange}
                  />
                </InputWrapper>
              </StyledFlexItem>

              <StyledFlexItem>
                <InputWrapper
                  label={translate(
                    "eva.main.validation.attributes.client_secret",
                  )}
                  required
                  error={EVAApiHelper.getResponseError(
                    "client_secret",
                    submitError,
                  )}
                >
                  <StyledInput
                    type="text"
                    placeholder={translate(
                      "eva.main.validation.attributes.client_secret",
                    )}
                    value={configData.client_secret}
                    onChange={onClientSecretChange}
                  />
                </InputWrapper>
              </StyledFlexItem>
            </StyledFlexRow>

            <InputWrapper
              label={translate(
                "eva.main.validation.attributes.employee_azure_group_id",
              )}
              error={EVAApiHelper.getResponseError(
                "employee_azure_group_id",
                submitError,
              )}
            >
              <StyledInput
                type="text"
                placeholder={translate(
                  "eva.main.validation.attributes.employee_azure_group_id",
                )}
                value={configData.employee_azure_group_id}
                onChange={onEmployeeAzureGroupIdChange}
              />
            </InputWrapper>

            <InputWrapper
              label={translate(
                "eva.main.validation.attributes.connect_employees_to_users",
              )}
              error={EVAApiHelper.getResponseError(
                "connect_employees_to_users",
                submitError,
              )}
            >
              <Select
                options={[
                  { value: true, label: translate("eva.main.general.yes") },
                  { value: false, label: translate("eva.main.general.no") },
                ]}
                value={configData.connect_employees_to_users}
                onChange={onConnectEmployeesToUsersChange}
              />
            </InputWrapper>
          </StyledFlexColumn>
        </FormContainer>
      </OverlayLoader>

      <AzureRoles
        configData={configData}
        setConfigData={setConfigData}
        roles={roles}
        formId={FORM_ID}
      />

      <AzureFieldMappings
        configData={configData}
        setConfigData={setConfigData}
        departments={departments}
        formId={FORM_ID}
      />
    </StyledFlexColumn>
  );
}

export default AzureConfigsPageView;
